export const LINE_HEIGHT_FACTOR = 1.5715;
export const LOGO_WIDTH = 230;
export const SMALL_LOGO_WIDTH = 100;
export const LOGO_HEIGHT = 130;
export const SMALL_LOGO_HEIGHT = 50;
export const LOGO_MARGIN = 30;
export const SVG_IMAGE_ZOOM = 4;
export const POLL_Y_POSITION_RATIO = 0.78;
export const POLL_OPTION_PADDING_RATIO = 0.05;
export const POLL_OPTION_GAP = 30;
export const POLL_BAR_Y_OFFSET = 43;
